module.exports = __webpack_public_path__ + "img/django-logo.5848661d.png";